import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio"]

  declare readonly radioTargets: HTMLInputElement[]

  connect() {
    this.sync()
  }

  sync() {
    const hash = window.location.hash.slice(1)
    const anchor = hash ? document.getElementById(hash) : null
    const radio =
      this.radioTargets.find((r) => r.value === hash) ??
      this.radioTargets.find((r) => this.panelFor(r)?.contains(anchor)) ??
      this.radioTargets[0]
    radio.checked = true
    this.loadVisibleVideos()
    this.pauseHiddenVideos()
    this.revealAnchor(anchor, radio)
  }

  changed(event: Event) {
    const platform = (event.target as HTMLInputElement).value
    // Turbo keeps its restoration identifier in history.state.
    const url =
      platform === this.radioTargets[0].value
        ? window.location.pathname + window.location.search
        : `#${platform}`
    history.replaceState(history.state, "", url)
    this.loadVisibleVideos()
    this.pauseHiddenVideos()
  }

  private panelFor(radio: HTMLInputElement) {
    return radio.closest("label")?.nextElementSibling
  }

  // FAQ deep links (Answer.url anchors) target elements inside a hidden panel: the
  // native fragment scroll can't reach them until the owning tab is active.
  private revealAnchor(anchor: HTMLElement | null, radio: HTMLInputElement) {
    if (!anchor || !this.panelFor(radio)?.contains(anchor)) return

    if (anchor instanceof HTMLDetailsElement) anchor.open = true
    anchor.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  private loadVisibleVideos() {
    const checked = this.radioTargets.find((radio) => radio.checked)
    checked
      ?.closest("label")
      ?.nextElementSibling?.querySelectorAll<HTMLIFrameElement>("iframe[data-src]")
      .forEach((frame) => {
        frame.src = frame.dataset.src ?? ""
        delete frame.dataset.src
      })
  }

  private pauseHiddenVideos() {
    this.radioTargets.forEach((radio) => {
      if (radio.checked) return
      radio
        .closest("label")
        ?.nextElementSibling?.querySelectorAll("iframe")
        .forEach((frame) => {
          frame.contentWindow?.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "https://www.youtube.com",
          )
        })
    })
  }
}
